/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingdeletepostdescription3Inputs */

const en_crosspostingdeletepostdescription3 = /** @type {(inputs: Crosspostingdeletepostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This removes the post from Pulsify. A post that is already live on Facebook or Instagram stays online – delete it there as well if you want it gone.`)
};

const de_crosspostingdeletepostdescription3 = /** @type {(inputs: Crosspostingdeletepostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Beitrag wird aus Pulsify entfernt. Ein schon veröffentlichter Beitrag bleibt auf Facebook oder Instagram online – lösch ihn dort zusätzlich, wenn er verschwinden soll.`)
};

/**
* | output |
* | --- |
* | "This removes the post from Pulsify. A post that is already live on Facebook or Instagram stays online – delete it there as well if you want it gone." |
*
* @param {Crosspostingdeletepostdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingdeletepostdescription3 = /** @type {((inputs?: Crosspostingdeletepostdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingdeletepostdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingdeletepostdescription3(inputs)
	return de_crosspostingdeletepostdescription3(inputs)
});
export { crosspostingdeletepostdescription3 as "crosspostingDeletePostDescription" }